import { IStep } from '@carm/_core/declarations/models/common';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { CadStep, TempImpStep, DutyDrawbackStep, MassAdjustmentStep, SDAStep, MPRCCStep, RDDBStep } from './common';

export const CadSteps: IStep[] = [
    {
        id: CadStep.Overview,
        name: 'concepts.declarations.cad_steps.overview',
        order: 0,
        hide: true,
        routeName: RoutesConst.Declarations_Mgt_OverviewRel,
    },
    {
        id: CadStep.GeneralDetails,
        name: 'concepts.declarations.cad_steps.general_details',
        order: 1,
        routeName: RoutesConst.Declarations_Mgt_General_DetailsRel,
    },
    {
        id: CadStep.Warehouse,
        name: 'concepts.declarations.cad_steps.warehouse',
        order: 2,
        routeName: RoutesConst.Declarations_Mgt_Warehouse_DetailsRel,
    },
    {
        id: CadStep.Invoices,
        name: 'concepts.declarations.cad_steps.invoices',
        order: 3,
        routeName: RoutesConst.Declarations_Mgt_Invoices_Rel,
    },
    {
        id: CadStep.Review,
        name: 'concepts.declarations.cad_steps.review_submit',
        order: 4,
        routeName: RoutesConst.Declarations_Mgt_Review_SubmitRel
    }
];

export const ConvertB3Steps: IStep[] = [
    {
        id: CadStep.Overview,
        name: 'concepts.declarations.cad_steps.overview',
        order: 0,
        hide: true,
        routeName: RoutesConst.Declarations_Mgt_OverviewRel,
    },
    {
        id: CadStep.GeneralDetails,
        name: 'concepts.declarations.cad_steps.general_details',
        order: 1,
        routeName: RoutesConst.Declarations_Mgt_General_DetailsRel,
    },
    {
        id: CadStep.Warehouse,
        name: 'concepts.declarations.cad_steps.warehouse',
        order: 2,
        routeName: RoutesConst.Declarations_Mgt_Warehouse_DetailsRel,
    },
    {
        id: CadStep.Invoices,
        name: 'concepts.declarations.cad_steps.invoices',
        order: 3,
        routeName: RoutesConst.Declarations_Mgt_Invoices_Rel,
    },
    {
        id: CadStep.Review,
        name: 'concepts.declarations.cad_steps.review_submit',
        order: 4,
        routeName: RoutesConst.Declarations_Mgt_Review_SubmitRel
    }
];

export const TempImpSteps: IStep[] = [
    {
        id: TempImpStep.Overview,
        name: 'concepts.declarations.cad_steps.overview',
        order: 0,
        hide: true,
        routeName: RoutesConst.Declarations_Temporary_importation_review_info_rel
    },
    {
        id: TempImpStep.GeneralDetails,
        name: 'concepts.declarations.cad_steps.general_details',
        order: 1,
        routeName: RoutesConst.Declarations_Temporary_importation_general_details_rel
    },
    {
        id: TempImpStep.Destination,
        name: 'concepts.declarations.cad_steps.destination',
        order: 2,
        routeName: RoutesConst.Declarations_Temporary_importation_destination_rel
    },
    {
        id: TempImpStep.Dates,
        name: 'concepts.declarations.cad_steps.dates',
        order: 3,
        routeName: RoutesConst.Declarations_Temporary_importation_dates_rel
    },
    {
        id: TempImpStep.VendorsGoods,
        name: 'concepts.declarations.cad_steps.vendor_goods',
        order: 4,
        routeName: RoutesConst.Declarations_Temporary_importation_vendors_goods_rel
    },
    {
        id: TempImpStep.Review,
        name: 'concepts.declarations.cad_steps.review_submit',
        order: 5,
        routeName: RoutesConst.Declarations_Temporary_importation_review_rel
    },
];

export const DutyDrawbackSteps: IStep[] = [
    {
        id: DutyDrawbackStep.GeneralDetails,
        name: 'concepts.declarations.cad_steps.general_details',
        order: 1,
        routeName: RoutesConst.DutyDrawbacks_General_Details_Rel
    },
    {
        id: DutyDrawbackStep.SelectLines,
        name: 'concepts.declarations.cad_steps.select_lines',
        order: 2,
        routeName: RoutesConst.DutyDrawbacks_Select_Lines_Rel
    },
    {
        id: DutyDrawbackStep.Claims,
        name: 'concepts.declarations.cad_steps.claims',
        order: 3,
        routeName: RoutesConst.DutyDrawbacks_Claims_Rel
    },
    {
        id: DutyDrawbackStep.Review,
        name: 'concepts.declarations.cad_steps.review_submit',
        order: 4,
        routeName: RoutesConst.DutyDrawbacks_Review_Rel
    },
];

export const MassAdjustmentSteps: IStep[] = [
    {
        id: MassAdjustmentStep.Reason,
        name: 'concepts.declarations.massAdjustments.steps.reason',
        order: 1,
        routeName: RoutesConst.MassAdjustments_Reason
    },
    {
        id: MassAdjustmentStep.AdjustmentLevel,
        name: 'concepts.declarations.massAdjustments.steps.level',
        order: 2,
        routeName: RoutesConst.MassAdjustments_Level
    },
    {
        id: MassAdjustmentStep.AdjustFields,
        name: 'concepts.declarations.massAdjustments.steps.fields',
        order: 3,
        routeName: RoutesConst.MassAdjustments_Fields
    },
    {
        id: MassAdjustmentStep.Review,
        name: 'concepts.declarations.massAdjustments.steps.review',
        order: 4,
        routeName: RoutesConst.MassAdjustments_Review
    },
];

export const SDASteps: IStep[] = [
  {
      id: SDAStep.CreateCase,
      name: 'concepts.declarations.summary_drawback_activity.mgt.createCase.stepperTitle',
      order: 1,
      routeName: RoutesConst.Declarations_SDA_Mgt_CreateCase_Rel
  },
  {
      id: SDAStep.UploadFile,
      name: 'concepts.declarations.summary_drawback_activity.mgt.uploadFile.stepperTitle',
      order: 2,
      routeName: RoutesConst.Declarations_SDA_Mgt_UploadFile_Rel
  }
];

export const MPRCCSteps: IStep[] = [
    {
        id: MPRCCStep.CreateCase,
        name: 'concepts.declarations.masterPRcreatecase.stepperCreateCase',
        order: 1,
        routeName: RoutesConst.Declarations_MPRCreatecase_Rel
    },
    {
        id: MPRCCStep.UploadFile,
        name: 'concepts.declarations.masterPRcreatecase.stepperUploadfile',
        order: 2,
        routeName: RoutesConst.Declarations_MPRCCUploadfile_Rel
    }
  ];
export const RDDBSteps: IStep[] = [
    {
        id: RDDBStep.ClaimantDetails,
        name: 'concepts.declarations.reqDDBUploadfile.stepperClaimantDetails',
        order: 1,
        routeName: RoutesConst.ReqDutyDrawBack_ClaimantDetail_Rel
    },
    {
        id: RDDBStep.UploadFile,
        name: 'concepts.declarations.reqDDBUploadfile.stepperUploadfile',
        order: 2,
        routeName: RoutesConst.ReqDutyDrawBack_UploadFile_Rel
    }
  ];
